import React, { useState } from 'react'
import { CheckMark } from '../../../../constants/svg'

const VideoShareModal = (shareModalData: any) => {
  const [successMessage, setSuccessMessage] = useState(false)

  const dynamicPath =
    window.location.protocol + '//' + window.location.hostname + window.location.pathname
  const finalUrl = dynamicPath + '?videoId=' + shareModalData?.content?.videoId

  const copyShareUrl = () => {
    navigator.clipboard.writeText(finalUrl)
    setSuccessMessage(!successMessage)

    setTimeout(() => {
      setSuccessMessage(successMessage)
    }, 3000)
  }

  return (
    <div
      role="tooltip"
      className="Video__Share-Popup popover bottom"
      style={{
        top: shareModalData?.content?.position?.top + 34,
        left: shareModalData?.content?.position?.left,
      }}>
      <div className="Video__Share-Arrow"></div>
      <div className="Video__Share-Content">
        <div className="Video__Share-title">{shareModalData?.content?.title}</div>
        <div className="Video__Share-clipboard">
          <div className="Video__Share-InputGroup">
            <input
              type="text"
              readOnly
              className="Video__Share-FormControl"
              title=""
              id="copy-text"
              value={finalUrl}
            />
            <span className="Video__Share-CopyBtn" onClick={copyShareUrl}>
              {!successMessage ? shareModalData?.content?.ctaText : <CheckMark />}
            </span>
          </div>
        </div>
        {successMessage && (
          <div className="Video__Share-SuccessText">{shareModalData?.content?.successMessage}</div>
        )}
      </div>
    </div>
  )
}

export default VideoShareModal
